import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function ReasonHelp({ theme, ...props }) {
  return (
    <svg
      width="23"
      height="28"
      xmlns="http://www.w3.org/2000/svg"
      className={cx(theme.container, theme[props.svg], props.className)}
    >
      <g fill="none" fillRule="evenodd" className={theme.stroke}>
        <path
          d="M14.074 26.444s-.104-1.763.104-2.903c.207-1.245.933-1.141.933-1.141h3.733c.934 0 1.141-.83 1.141-1.556 0-.725 0-1.555.104-2.696.104-1.14.311-1.867.311-1.867h1.037c.726 0 .415-.933.415-.933l-1.763-3.318v-1.763c0-1.245-.311-3.63-1.556-5.29-1.763-2.073-4.355-3.421-7.259-3.421a9.516 9.516 0 0 0-9.54 9.54c0 1.556.414 3.008 1.036 4.356 1.245 2.696 2.904 5.185 2.904 7.363v3.526"
          fill="#FFF"
        />
        <path
          d="M14.074 26.444s-.104-1.763.104-2.903c.207-1.245.933-1.141.933-1.141h3.733c.934 0 1.141-.83 1.141-1.556 0-.725 0-1.555.104-2.696.104-1.14.311-1.867.311-1.867h1.037c.726 0 .415-.933.415-.933l-1.763-3.318v-1.763c0-1.245-.311-3.63-1.556-5.29-1.763-2.073-4.355-3.421-7.259-3.421a9.516 9.516 0 0 0-9.54 9.54c0 1.556.414 3.008 1.036 4.356 1.245 2.696 2.904 5.185 2.904 7.363v3.526"
          stroke="#4A4A4A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.711 12.963c-1.763-1.244-1.763-3.837.104-4.874-.726-3.526 5.807-3.63 7.466-2.696 1.867 1.037 4.045 4.044.83 4.459 0 2.8-6.637 4.46-8.4 3.111z"
          fill="#FF6900"
        />
      </g>
    </svg>
  )
}

ReasonHelp.propTypes = {
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
}
